import { render, staticRenderFns } from "./TermoDesentranhamentoJuntar.vue?vue&type=template&id=3ac19268&scoped=true"
import script from "./TermoDesentranhamentoJuntar.vue?vue&type=script&lang=js"
export * from "./TermoDesentranhamentoJuntar.vue?vue&type=script&lang=js"
import style0 from "./TermoDesentranhamentoJuntar.vue?vue&type=style&index=0&id=3ac19268&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac19268",
  null
  
)

export default component.exports